import { environment } from '../configuration/env';

export const linksDoc = {
  UPLOAD_ANAGRAPHICS: 'admin-e-delegati/struttura-aziendale/#caricamento-delle-anagrafiche',
  ADMIN_AND_DELEGATES_REVIEW_AND_CONFIRM:
    'admin-e-delegati/struttura-aziendale/#revisione-e-conferma',
  ADMIN_AND_DELEGATES_ROLES_AND_PERMISSIONS:
    'admin-e-delegati/struttura-aziendale/#tab-admin-e-delegati--gestione-ruoli-e-poteri',
  CORE_CONCEPTS_AND_SLASH_MODEL: 'concetti-chiave/',
  SOFT_SKILLS: 'concetti-chiave/le-soft-skill-di-slash/',
  HARD_SKILLS: 'concetti-chiave/hard-skills/',
  DEPARTMENTS: 'admin-e-delegati/struttura-aziendale/#2-dipartimenti',
};

export const getDocLink = (key: keyof typeof linksDoc) => {
  return `${environment.VITE_APP_PUBLIC_DOCS}/${linksDoc[key]}`;
};
